module.exports = __webpack_public_path__ + "static/epitome-banner-e04eeb96af2a83bc84338154959f52a2.png";